'use strict';

function test(pattern, str) {
    const patterns = {
        alphaNumeric: /^[a-zA-Z0-9]+$/,
        email: /^[\w.+\-]+@[\w.\-]+\.[\w]{2,6}$/, // eslint-disable-line
        phone: /^\d{3}-\d{3}-\d{4}$/,
        name: /^[a-zA-Z0-9 .-]+$/
    };

    const regex = patterns[pattern];
    return regex ? regex.test(str) : false;
}

module.exports = {
    test: test,
};
